import React, { ReactElement } from 'react'
import { UpsertLabel } from './UpsertLabel'
import { UpsertModal } from '../../../../components'
import { useTranslations } from 'hooks'
import translations from './UpsertLabel.i18n.json'
import { Label } from 'libs/api'

interface Props {
  children: ({ open }: { open: () => void }) => ReactElement
  refetch: () => Promise<unknown>
  item?: Label
}

export function UpsertLabelModal({ children, refetch, item }: Props) {
  const labels = useTranslations(translations)

  return (
    <UpsertModal labels={labels} Modal={UpsertLabel} item={item} onSuccess={refetch}>
      {children}
    </UpsertModal>
  )
}
